import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Crown, Calendar, RefreshCw } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export const ManagePlanModal = ({ open, onClose, onRenew }) => {
  const { user } = useAuth();
  const status = user?.subscription_status || "";
  const isGift = status.startsWith("gift");
  const exp = user?.pro_expires_at;
  const isPro = user?.plan === "pro";
  const ms = exp ? new Date(exp) - new Date() : null;
  const expired = ms != null && ms <= 0;
  const fmt = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" }) : null);

  const renew = () => { onClose(); onRenew && onRenew(); };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md">
        <DialogTitle className="flex items-center gap-2 font-serif text-2xl"><Crown className="h-5 w-5 text-accent" /> Manage Plan</DialogTitle>
        <DialogDescription className="sr-only">View your Pro pass status and renew if needed.</DialogDescription>

        <div className="space-y-4">
          <div className="rounded-2xl border border-border p-4">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">Current plan</p>
            <p data-testid="manage-plan-name" className="font-serif text-2xl font-bold">
              {isPro && !expired ? "Lectura Pro" : "Free"}
              {isPro && isGift && <span className="ml-2 text-sm text-accent align-middle">(gifted)</span>}
            </p>
            {isPro && exp && (
              <p data-testid="manage-plan-expiry" className="mt-1 flex items-center gap-1.5 text-sm text-muted-foreground">
                <Calendar className="h-4 w-4" />
                {expired ? `Ended ${fmt(exp)}` : `Access until ${fmt(exp)}`}
              </p>
            )}
            {isPro && isGift && !exp && (
              <p className="mt-1 text-sm text-muted-foreground">Gifted Pro — no expiry, no charges.</p>
            )}
            {!isPro && <p className="mt-1 text-sm text-muted-foreground">You're on the free plan.</p>}
          </div>

          <p className="text-xs text-center text-muted-foreground">
            Lectura Pro is a one-time pass paid by card via Stripe — there's no automatic renewal. We'll remind you before it ends.
          </p>

          {(!isPro || expired || (exp && !isGift)) && (
            <button
              data-testid="renew-pro-btn"
              onClick={renew}
              className="w-full flex items-center justify-center gap-2 rounded-xl bg-accent text-accent-foreground py-3 font-semibold hover:opacity-90 transition"
            >
              <RefreshCw className="h-4 w-4" /> {isPro && !expired ? "Extend Pro" : "Get Lectura Pro"}
            </button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};
